module.exports = __webpack_public_path__ + "static/media/equalizer_prevalence.3c468e08.svg";